"use client";

export default function AITraining() {
  const features = [
    {
      title: "Boost AI Productivity",
      description: "Learn Proven AI Frameworks & Strategies For 10X Efficiency",
      icon: "/images/ai1.svg", 
    },
    {
      title: "Hands-On AI Training",
      description: "Get hands-on experience with AI tools you'll actually use",
      icon: "/images/ai2.svg", 
    },
    {
      title: "Learn 15+ AI Tools",
      description: "Unlock a powerful set of AI tools to streamline your tasks",
      icon: "/images/ai3.svg", 
    },
    {
      title: "Build A Custom GPT Bot",
      description: "Learn how to create your own GPT-powered bot to boost productivity",
      icon: "/images/ai4.svg",
    },
  ];

  return (
    <section className="w-full py-6 md:py-12">
      <div className="w-[90%] md:w-[80%] mx-auto">
        {/* Header Section */}
        <div className="mb-8 text-left">
          <h2 className="text-[#002726] text-[28px] md:text-[32px] font-medium mb-3 w-full md:w-[80%]">
           The AI Training 10M+ Professionals Can't Stop Recommending
          </h2>
          <p className="text-[#002726] text-base md:text-lg font-normal">
            Here&apos;s a sneak peek of what you&apos;ll get when you register for the workshop...
          </p>
        </div>

        {/* Features Grid */}
        <div className="flex flex-col md:grid md:grid-cols-2 gap-4 md:gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="rounded-xl p-4 border border-[#818490] text-left"
              style={{ backgroundColor: "#FFFAF1" }}
            >
              {/* SVG Icon */}
              {feature.icon && (
                <div className="mb-3 w-8 h-8">
                  <img
                    src={feature.icon}
                    alt={feature.title}
                    className="w-8 h-8 object-contain"
                  />
                </div>
              )}
              <h3 className="text-[#002726] text-base md:text-lg font-medium mb-1">
                {feature.title}
              </h3>
              <p className="text-[#002726] text-sm md:text-base font-normal">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
